export default __webpack_public_path__ + "static/media/05.88e498bd.png";